import { StyleSheet } from 'react-native';

const CheckBoxStyle = StyleSheet.create({
    checkboxContainer: {
        borderWidth: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 6
    },
    iconPosition: {
        width: '98%',
        height: '98%',
        borderRadius: 6,
        justifyContent: 'center',
        alignItems: 'center'
    }
});

export default CheckBoxStyle;
